import type { StylePropertiesTypes } from '@wix/document-services-types'
import { getKeywordString, getConverterString } from '../../utils/converterHelpers'

/** Internal Converters */
const borderConverter = (prop: StylePropertiesTypes.Border) => {
	const style = prop.style && getKeywordString(prop.style)

	// For dynamic types, use getConverterString with the dynamic type
	const width = prop.width && getConverterString(prop.width.type, prop.width)
	const color = prop.color && getConverterString(prop.color.type, prop.color)

	return {
		width,
		style,
		color,
		[prop.type]: 'var(--{propName}-width) var(--{propName}-style) var(--{propName}-color)',
	}
}

/** External Map */
export const borderConverterMap = {
	Border: borderConverter,
}
